module.exports = __webpack_public_path__ + "static/media/system-of-a-down1.9c9f8b85.jpg";